// Components
import React, { Component, PropTypes } from 'react';
import Card from '../tc-ui/search-bar-card';
import LeftNav from './integration-left-nav';
import Auth from './integration-tourplan-auth';
import LogIn from './integration-tourplan-login';
import Contracts from './integration-contracts';
import languagesObj from '../../localization/languages.json';
const languageSettings = languagesObj['en-US'];
import RateNameTextSettings from './settings/rate-name-text-settings';
import ExtraSettings from './settings/extras-settings';
import CancelHourSettting from './settings/cancel-hour-settings';
import TaxSettings from './settings/tax-settings';
import PriceCodes from './settings/price-codes';
import NotesSettings from './settings/notes-settings';

class Integration extends Component {
  constructor(props) {
    super(props);
    this.populateState(props);
  }

  componentWillReceiveProps(nextProps) {
    this.populateState(nextProps);
  }

  setAuthenticated() {
    this.setState({ authenticated: true });
  }

  populateState(props) {
    const integration = props.integration;
    this.state = {
      get authenticated() {
        if (integration.auth) {
          if (integration.auth.user_name) return true;
          return false;
        }
      },
    };
  }

  sendRouteName(routeName) {
    this.setState({
      routeName,
    }, () => {
      this.filterResults(routeName);
    });
  }

  render() {
    const { history } = this.props;
    const leftContent = (() => {
      if (history.isActive('/integration/authentication')) {
        return (
          <Card title={languageSettings.integration.routeNames.authentication}>
            { this.state.authenticated ? <Auth {...this.props} /> :
              <LogIn {...this.props} transition={this.setAuthenticated.bind(this)} type="login"/>}
          </Card>
        );
      }
      if (history.isActive('/integration/contracts')) return <Contracts {...this.props}/>;
      if (history.isActive('/integration/settings/rate-name-text')) return <RateNameTextSettings {...this.props}/>;
      if (history.isActive('/integration/settings/tax')) return <TaxSettings {...this.props}/>;
      if (history.isActive('/integration/settings/extras')) return <ExtraSettings {...this.props} />;
      if (history.isActive('/integration/settings/pricecodes')) return <PriceCodes {...this.props} />;
      if (history.isActive('/integration/settings/notes')) return <NotesSettings {...this.props}/>;
      return <CancelHourSettting {...this.props} />;
    })();

    return (
      <div className="l-app-content l-left-nav-with-content" style={{ maxWidth: 'calc(100% - 48px)' }}>
        <LeftNav
          {... this.props}
          className="integration-left-nav l-left-nav"
          sendRouteName={this.sendRouteName}
        />
        <div className="l-left-nav-content" style={{ overflowX: 'hidden' }}>
          {leftContent}
        </div>
      </div>
    );
  }
}

Integration.propTypes = {
  history: PropTypes.object,
  integration: PropTypes.object,
};

export default Integration;



// WEBPACK FOOTER //
// ./src/app/components/integration/integration.jsx